module.exports = __webpack_public_path__ + "img/bg_theme_right.524c1a63.svg";